export default __webpack_public_path__ + "static/media/whiteig.7207d955.svg";